module.exports = __webpack_public_path__ + "static/media/heart21.77ef6b92.svg";